import { Component, Input, OnDestroy } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Design } from '../../design-and-amount-settings';
import { GiftCardPurchaseFormService } from '../../gift-card-purchase-form/gift-card-purchase-form.service';
import { InputData, OutputData } from './designs-modal/data.interface';
import { DesignsModalComponent } from './designs-modal/designs-modal.component';

@Component({
    selector: 'ols-design-selection',
    templateUrl: './design-selection.component.html',
    styleUrls: ['./design-selection.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class DesignSelectionComponent implements OnDestroy {
    @Input() designs: Design[];

    selectableDesignImagesThatAreLoaded = {};

    private ngUnsubscribe = new Subject();

    get selectedGiftCardDesignID() {
        return this.formService.giftCardDesignID;
    }

    constructor(
        private dialog: MatDialog,
        private formService: GiftCardPurchaseFormService
    ) {}

    getFeaturedDesigns(): Design[] {
        return this.designs?.filter((design) => design.isFeatured).splice(0, 5);
    }

    selectableDesignImageIsReady(designID: number) {
        this.selectableDesignImagesThatAreLoaded[designID] = true;
    }

    isSelectableDesignImageReady(designID: number) {
        return this.selectableDesignImagesThatAreLoaded[designID];
    }

    designSelected(design: Design) {
        if (this.selectedGiftCardDesignID.value !== design.id) {
            this.formService.selectDesign(design);
        }
    }

    openMoreDesignsModal() {
        const config = new MatDialogConfig<InputData>();
        config.data = {
            designs: this.designs,
            selectedDesignID: this.selectedGiftCardDesignID.value,
        };
        config.maxWidth = '58.75rem';

        const dialogRef = this.dialog.open(DesignsModalComponent, config);
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((output: OutputData) => {
                if (output?.selectedDesignID) {
                    if (
                        output.selectedDesignID !==
                        this.selectedGiftCardDesignID.value
                    ) {
                        const design: Design = this.designs.find(
                            (x) => x.id === output.selectedDesignID
                        );
                        this.designSelected(design);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
